<div class="form-page-container">
  <div class="header-buttons">
    <nts-text-button class="close-command" [icon]="'cancel'" (onClicked)="onExit()"></nts-text-button>
  </div>
  <div class="step-page-container">
    <nts-loader *ngIf="stepLoading"
      [isVisible]="true" class="loader-blank"
      [animation]="true"
      [skipHeader]="false"
      [text]="stepLoadingText">
    </nts-loader>
    <div class="form-step" [@routeAnimations]="getRouteAnimationData()">
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </div>
  </div>
  <div *ngIf="currentViewModel?.hasActionsButtons | async" class="actions-container">
    <nts-text-button [label]="'CMD_Back_DisplayName'|NTSTranslate" (onClicked)="onPreviousStep()"
      [isDisabled]="currentViewModel?.isPreviousDisabled | async">
    </nts-text-button>
    <div class="forward-buttons">
      <nts-text-button class="secondary" [label]="forwordWithNoReceiptButtonLabel" (onClicked)="forwardWithNoReceipt()"
        *ngIf="isOnFirstStep() && !(this.stepsService.isReadOnly$ | async)" [isDisabled]="stepLoading">
      </nts-text-button>
      <nts-text-button [label]="'CMD_ReceiptLastStep_Draft' | NTSTranslate" (onClicked)="onNextStep(true)"
        *ngIf="!(currentViewModel?.hideNext | async) && !isOnFirstStep() && (this.isOnline$ | async)  && !(this.stepsService.isReadOnly$ | async) && this?.stepsService?.expenseAnnotationId == undefined "
        [isDisabled]="stepLoading || !nextStepEnabled">
      </nts-text-button>
      <nts-filled-button [label]="forwordButtonLabel" (onClicked)="onNextStep()"
        *ngIf="!(currentViewModel?.hideNext | async)" [isDisabled]="stepLoading || !nextStepEnabled">
      </nts-filled-button>
    </div>

  </div>
</div>
